import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Footer from '../elements/Footer';
import Accordion from 'react-bootstrap/Accordion';




function BookKeeping() {
  return (
    <div className='book-keeping'>
        <div className="">
            <Header/>
            <main>
                <Breadcrumb title="Book Keeping" sub_title="Service" active="Book Keeping"/>
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                            <div className="tmp-large-service-detials">
                                <img
                                src="assets/images/services/bookkeeping.jpg"
                                alt="business formation"
                                />
                            </div>
                            {/* single service details component */}
                            <div className="single-service-details-component mt--40">
                                <h2 className="title split-collab">
                                Looking for a reliable Bookkeeping Solution?
                                </h2>
                                <p className="disc mb--20">
                               Let us take the burden of managing your finances off your shoulders by our personalized, reliable bookkeeping services. We offer record keeping, timely financial reporting and full transparency so our clients can do what they do best. We set up and use Quickbooks to ensure your financial data is organized, secure and easily accessible.
                                </p>
                                <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Instant Business Growth</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Expert Team Members</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Easy Customer Service</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>24/7 Quality Service</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                </div>
                            </div>
                            {/* single service details component end */}
                            <div className="row g-5 mt--10">
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Streamlining Your Financial Operations with Care</h6>
                                    <p className="disc">
                                      We take the stress out of day-to-day financial tasks by handling your accounts payable and receivable with accuracy and care. From tracking incoming payments to managing outgoing expenses, we make sure everything runs smoothly. We also perform through bank and credit card reconciliations, giving you a clear, up-to-date picture of your financial position.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Smart Tools + Expert Advice = Financial Clarity</h6>
                                    <p className="disc">
                                       Accurate, systematic recording of financial transactions is at the core of what we do, designed to support businesses of every type and size. We make the process straight forward and stress-free and straightforward by combining smart tools and expert advice from our experienced team. With our guidance you will gain valuable insights into your finances, stay organized and have more time to focus on what matters most: growing your business.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                            </div>
                            <div className="row g-5 mt--10">
                                <div className="col-lg-12">
                                <h2 className="title split-collab">Empowering You to Take Control of Your Finances with Confidence</h2>
                                <p className="disc mb--20">
                                 Our goal is to help you control your finances with confidence, We provide clear, reliable guidance so you can make smart financial decisions for your future while being compliant with the ever-changing tax laws and regulations. Whether you are managing a business or personal finances, we are here to simplify the process and support your success every step of the way.
                                </p>
                                </div>
                                
                                
                                
                            </div>
                            <div className="row mt--10">
                                <div className="col-lg-12">
                                <div className="faq-accordion">

                                    <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>What does your bookkeeping service include?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                                </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                We handle daily transaction recording, account reconciliation, expense tracking, and financial reporting, ensuring your books stay accurate, organized, and up to date.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>How often do you update financial records?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                               Depending on your needs, we can manage bookkeeping on a weekly, monthly, or quarterly basis. Our goal is to keep your financial data current so you always have a clear picture of your business performance.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>
                                                   Can you work with my existing accounting software?
                                                </span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Yes! We work seamlessly with popular platforms like QuickBooks, Xero, and FreshBooks, integrating your current systems for smooth and efficient financial management.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>

                                    <div className="faq-buttom">
                                    <h4 className="title">Still Have More Questions?</h4>
                                    <p>
                                                      Contact Our <a style={{color:"#F8E3E3"}} href="/contact-us">Expert Support Team</a>
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                            <div className="side-bar-details-page">
                                
                                {/* single bar */}
                                <div className="signle-side-bar category-area">
                                <div className="header">
                                    <h3 className="title">Service List</h3>
                                </div>
                                <div className="body">
                                    {/* single category */}
                                    <a href="/business-formation" className="single-category">
                                    <p>Business Formation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/payroll-management" className="single-category">
                                    <p>Payroll Management</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/tax" className="single-category">
                                    <p>Tax</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/business-consultation" className="single-category">
                                    <p>Business Consultation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                <div className="signle-side-bar call-to-action">
                                <div className="easy-call-to-action">
                                    <div className="icon-center-call">
                                    <i className="fa-light fa-phone" />
                                    </div>
                                    <h3 className="title">Need any help?</h3>
                                    <p className="disc">
                                    We are here to help our customer any time. You can call on
                                    24/7 To Answer Your Question.
                                    </p>
                                    <a href="tel:8323510418">832-351-0418</a>
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                {/* <div className="signle-side-bar brochure">
                                <div className="header">
                                    <h3 className="title">Brochure</h3>
                                </div>
                                <div className="body">
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Investment Policy</p>
                                    <i className="fa-light fa-cloud-arrow-down" />
                                    </a>
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Company Details</p>
                                    <i className="fa-light fa-note" />
                                    </a>
                                  
                                </div>
                                </div> */}
                                {/* single bar end */}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default BookKeeping